var _defs, _rect, _circle, _circle2, _g, _g2, _g3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f0f9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e0f2fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b82f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purpleGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4f46e5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "url(#bgGradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 150,
    r: 100,
    fill: "#dbeafe",
    opacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 450,
    r: 80,
    fill: "#dbeafe",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 300)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 120,
    fill: "white",
    filter: "drop-shadow(0px 10px 15px rgba(0, 0, 0, 0.1))"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50, -50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -30,
    width: 60,
    height: 60,
    rx: 15,
    fill: "url(#blueGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10,-5 C-10,-12 -5,-17 2,-17 C7,-17 12,-14 13,-9 C14,-13 18,-15 22,-15 C28,-15 33,-10 33,-4 C33,3 28,8 22,8 L-7,8 C-13,8 -18,3 -18,-3 C-18,-5 -17,-7 -15,-9 C-13,-11 -10,-11 -10,-5 Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, -50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -30,
    width: 60,
    height: 60,
    rx: 15,
    fill: "url(#purpleGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15,-15 L15,-15 L15,15 L-15,15 Z",
    fill: "none",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8,-8 L8,-8 M-8,0 L8,0 M-8,8 L8,8",
    fill: "none",
    stroke: "white",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -30,
    width: 60,
    height: 60,
    rx: 15,
    fill: "url(#blueGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-20 L-15,-5 L-5,-5 L-5,15 L5,15 L5,-5 L15,-5 Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -30,
    width: 60,
    height: 60,
    rx: 15,
    fill: "url(#purpleGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15,0 L-5,10 L-15,20 M15,0 L5,10 L15,20 M0,-10 L-5,20",
    fill: "none",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("line", {
    x1: -35,
    y1: -35,
    x2: 35,
    y2: -35,
    stroke: "#bfdbfe",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: -35,
    y1: 35,
    x2: 35,
    y2: 35,
    stroke: "#bfdbfe",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: -35,
    y1: -35,
    x2: -35,
    y2: 35,
    stroke: "#bfdbfe",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: -35,
    x2: 35,
    y2: 35,
    stroke: "#bfdbfe",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -80,
    cy: 0,
    r: 5,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 0,
    r: 5,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -80,
    r: 5,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 80,
    r: 5,
    fill: "#3b82f6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -25,
    width: 80,
    height: 50,
    rx: 10,
    fill: "white",
    filter: "drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.1))"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25,
    y1: -10,
    x2: 25,
    y2: -10,
    stroke: "#e0e7ff",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25,
    y1: 0,
    x2: 15,
    y2: 0,
    stroke: "#e0e7ff",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25,
    y1: 10,
    x2: 5,
    y2: 10,
    stroke: "#e0e7ff",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 420)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -30,
    width: 90,
    height: 60,
    rx: 10,
    fill: "white",
    filter: "drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.1))"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -15,
    width: 60,
    height: 30,
    rx: 5,
    fill: "#eff6ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 0,
    r: 8,
    fill: "#3b82f6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M700,100 L730,150 L700,200 L670,150 Z",
    fill: "#93c5fd",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100,100 L130,120 L100,140 L70,120 Z",
    fill: "#93c5fd",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M600,500 L640,520 L600,540 L560,520 Z",
    fill: "#93c5fd",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIllustration);
export default __webpack_public_path__ + "static/media/hero-illustration.7acb08206a53649d9a432853d328d9c9.svg";
export { ForwardRef as ReactComponent };